module.exports = __webpack_public_path__ + "f06268213f58eaa54100d09fae61d654.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ii/ii04.jpg
// module id = 650
// module chunks = 0